import { environment as prodEnv } from './environment.prod';
import { universal } from './environment.universal';
import { base } from './environment.base';

const universalDomain = 'localhost';
const universalPort = universal.port;

const universalServer = {
    domain: 'main.internal.yeshiva.org.il',
    port: '',
    protocol: 'http://',
};

const directServer = {
    domain: 'direct.internal.yeshiva.org.il',
    port: '',
    protocol: 'http://',
};

//change for local
// const localServer = {
//     domain: "localhost",
//     port: "8042",
//     protocol: "http://"
// };
//universalServer = localServer;

const datastore = {
    domain: universalServer.domain + '/warehouse',
    port: '',
    protocol: 'http://',
};

//sockets connect only in the browser (WebSocketService bails on the server), and this
//file is baked into the BROWSER bundle of the universal build too - an internal domain
//here sends every visitor to main.internal. Blank = same-origin (io('/namespace')).
const sameOriginSockets = {
    domain: '',
    port: '',
    protocol: '',
};

//chatbot calls run only in the browser (user-triggered from the chat widget), and this
//file is baked into the BROWSER bundle too - an internal domain here sends every visitor
//to chatbot.internal:3000. Blank = same-origin ('/api/chatbot/...' on whichever of the
//two public domains the visitor is on), same as prod non-universal (chatbot: server).
const sameOriginChatbot = {
    domain: '',
    port: '',
    protocol: '',
};

export const environment = {
    production: prodEnv.production,
    app: {
        domain: universalDomain,
        port: universalPort,
    },
    proxySource: directServer,
    api: universalServer,
    assets: universalServer,
    template: universalServer,
    warehouse: datastore,
    sockets: sameOriginSockets,
    pic: prodEnv.pic,
    video: prodEnv.video,
    chatbot: sameOriginChatbot,
    googleApiKey: prodEnv.googleApiKey,
    calendarMapsKey: prodEnv.calendarMapsKey,
    recaptchaV2SiteKey: '6LescXMUAAAAAOBdCy7elPzw4VSxjuGOhzNdZOMH',
    googleAuthClientId: prodEnv.googleAuthClientId,
    nihulDomain: prodEnv.nihulDomain,
};
